import MediaCard from "@/components/base/MediaCard";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatest } from "@/utils/media";

export default function LatestNews() {
  const latest = getLatest(6);

  return (
    <section className="border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Latest"
          title="最新影视资讯"
          subtitle="按发布时间排序，及时掌握电影、电视剧与综艺的最新动态。"
          moreTo="/category"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}